import React from 'react';

import useDocumentTitle from '../../hooks/useDocumentTitle';

import { DocsPageProvider } from '../../contexts/docsPageContext';

import FolderSidePanel from './FolderSidePanel/FolderSidePanel';
import FolderAndDocumentIndex from './FolderAndDocumentIndex/FolderAndDocumentIndex';
import FolderAndDocsDragLayer from './FolderAndDocsDragLayer/FolderAndDocsDragLayer';

const DocsPage = () => {
    useDocumentTitle('Docs');

    return (
        <div className="page-position flex">
            <FolderSidePanel />

            <FolderAndDocumentIndex />

            <FolderAndDocsDragLayer />
        </div>
    );
};

const WrappedDocsPage = () => (
    <DocsPageProvider>
        <DocsPage />
    </DocsPageProvider>
);

export default WrappedDocsPage;
